import React from 'react';

function AddRecommendedBulbsTemplate ({ modelAttributes }) {

	const { IsRecommendedBulbReplaced, ShowAddRecommendedBulbOption } = modelAttributes;

	return (
		<>
			{ShowAddRecommendedBulbOption && (
				<>
					<span className="lpIcon-bulb02 recommendedBulbIcon" />
					<button type="button" id="cartAddRecommendedBulbs" className="calloutBtn btnBlack xSmall">
						Add Recommended Bulbs
					</button>
				</>
			)}
			{IsRecommendedBulbReplaced && (
				<div className="recommendedBulbReplacedMessage">
					<p>Due to availability, bulb recommendations have changed.</p>
					<div className="tac">
						<a className="calloutBtn alt1 xSmall close dismiss">Dismiss</a>
					</div>
				</div>
			)}
		</>
	);

}

export default AddRecommendedBulbsTemplate;
